<div *ngIf="items.length"
  class="drv-dropdown"
  [ngClass]="className"
  [class.dropdown--disabled]="isDisabled"
  (bitfClickOutside)="isOpen = false">
  <div *ngIf="!enableSearch"
    (click)="toggleDropdown()"
    class="dropdown-toggle"
    [class.open]="isOpen">
    <div class="d-flex">
      <rmx-icon *ngIf="prefixIcon"
        [name]="prefixIcon"
        class="drv-dropdown-prefix-icon"></rmx-icon>
      <img *ngIf="customPrefixIcon"
        class="drv-dropdown-prefix-icon"
        [src]="customPrefixIcon"
        alt="">
      <span *ngIf="!staticLabel"
        class="drv-dropdown-label"
        [attr.data-label]='displayLabel'>
        {{ (selectedItem ? selectedItem.label || '' : label) | translate }}
      </span>
      <span *ngIf="staticLabel"
        class="drv-dropdown-label"
        [attr.data-label]='displayLabel'>{{ label }}</span>
    </div>
    <rmx-icon (click)="onArrowClick($event)"
      [name]="isOpen ? 'arrow-up-s-fill' : 'arrow-down-s-fill'"
      class="dropdown-toggle-icon"></rmx-icon>
    <rmx-icon (click)="onArrowClick($event)"
      [name]="isOpen ? 'arrow-up-s-line' : 'arrow-down-s-line'"
      class="dropdown-toggle-icon-age"></rmx-icon>
  </div>
  <div *ngIf="enableSearch"
    class="dropdown-toggle-search"
    [class.open]="isOpen">
    <input #searchInput
      [(ngModel)]="searchPhrase"
      [class.placeholder]="!selectedItem"
      [placeholder]="(selectedItem ? selectedItem.label || '' : label) | translate"
      name="search"
      class="drv-dropdown-input mt-0"
      autocomplete="off"
      type="text"
      (keyup)="onSearch()"
      (click)="onSearch()">
    <rmx-icon (click)="toggleDropdown()"
      name="search-2-line"
      class="dropdown-toggle-icon"></rmx-icon>
  </div>

  <ul class="dropdown-options"
    [class.open]="isOpen"
    [class.open-search]="enableSearch">
    <perfect-scrollbar class="dropdown-perfect-scrollbar"
      [style.height.px]="areaHeight"
      [config]="{ suppressScrollX: true }">
      <div *ngIf="!enableSearch">
        <li class="dropdown-option"
          [class.selected]="isSelected(item)"
          [class.dropdown-option--disabled]="item.disabled"
          (click)="chooseOption(item)"
          *ngFor="let item of items">{{ item.label | translate }}</li>
      </div>
      <div *ngIf="enableSearch">
        <li *ngFor="let item of filteredItems"
          class="dropdown-option"
          [class.dropdown-option-multiple]="mode === eDropdownMode.MULTIPLE_SELECTION"
          [class.dropdown-option--selected]="item.isSelected"
          [class.dropdown-option--disabled]="item.disabled">
          <label class="checkbox-wrapper">
            <input type="checkbox"
              id="checkbox"
              [disabled]="item.disabled ? true : null"
              (change)="changeCheckbox(item, $event)"
              [checked]="item.isSelected">
            <div class="checkbox-container">
              <rmx-icon name="check-line"
                class="checkbox-check-sign hero-icon-white"></rmx-icon>
            </div>
            <span>{{ item.label | translate }}</span>
          </label>
        </li>
      </div>
    </perfect-scrollbar>
  </ul>

</div>